import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Carousel from "./Carousel";
// import CocoPeatProcessing from "./CocoProcess";
import CocoCoirExporters from "./pages/CocoPeatExport";
import ProductGrid from "./pages/ProductCard";
import Testimonials from "./pages/Testimonials";
import PromoteGallery from "./pages/PromoteGallery";
import AutoPlayVideos from "./pages/VideoGallery";
import StatisticsBanner from "./pages/StatsBanner";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";

const Home = () => {
  const [showOptions, setShowOptions] = useState(false);
  const whatsappNumber = "+919492228585";
  const whatsappMessage = encodeURIComponent(
    "Hello Mr.Ramana Sir! I'm interested in ordering the Cocopeat Products. Could you please provide more details?"
  );

  const handleOrderClick = () => {
    setShowOptions(!showOptions);
  };

  return (
    <div>
      <Helmet>
        <title>Tirumala Cocopeat | Best Cocopeat in Andhra Pradesh | Anantapur | Exporters & Suppliers</title>
        <meta name="description" content="Tirumala Cocopeat is the leading manufacturer, supplier, and exporter of premium quality cocopeat in Andhra Pradesh, Anantapur. Discover the best cocopeat products for agriculture, horticulture, hydroponics, and global exports. Order cocopeat bricks, blocks, and bulk loads directly from the top exporters in India." />
        <meta name="keywords" content="Tirumala Cocopeat, best cocopeat in Andhra Pradesh, Anantapur, cocopeat exporters, cocopeat suppliers, cocopeat manufacturers, cocopeat blocks, cocopeat bricks, bulk cocopeat, cocopeat for agriculture, cocopeat for hydroponics, cocopeat for horticulture, best cocopeat exporters, cocopeat India, organic cocopeat, premium cocopeat, cocopeat delivery, cocopeat near me, cocopeat Anantapur, cocopeat Andhra Pradesh, cocopeat global export, cocopeat soil conditioner, cocopeat growing medium, cocopeat online, cocopeat price, cocopeat bulk order, cocopeat for nurseries, cocopeat for greenhouses, cocopeat for plants, cocopeat for farming, cocopeat for export, cocopeat sustainable, cocopeat eco-friendly" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Tirumala Cocopeat | Best Cocopeat Exporters in Andhra Pradesh" />
        <meta property="og:description" content="Order premium cocopeat from Tirumala Cocopeat, the top supplier and exporter in Anantapur, Andhra Pradesh. Best for agriculture, horticulture, and export needs." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://tirumalacocopeat.vercel.app/" />
      </Helmet>
      <Carousel />
      {/* <CocoPeatProcessing /> */}
      <CocoCoirExporters />
      <ProductGrid />
      <PromoteGallery />
      <AutoPlayVideos />
      <StatisticsBanner />
      <Testimonials />

      <div
        onClick={handleOrderClick}
        className="fixed bottom-6 right-6 bg-green-600 text-white px-6 py-3 rounded-full shadow-lg hover:bg-green-700 transition-all duration-300 flex items-center space-x-2 group cursor-pointer hover:scale-105"
      >
        <FaWhatsapp className="text-2xl animate-bounce" />
        <span className="transition-transform duration-300 group-hover:translate-x-1">
          Order Now
        </span>
      </div>

      <div
        className={`fixed bottom-20 right-6 transform transition-all duration-300 ease-in-out ${
          showOptions
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-10 pointer-events-none"
        }`}
      >
        <div className="bg-white shadow-lg p-4 rounded-lg flex flex-col space-y-3">
          <a
            href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-all duration-300 hover:scale-105 group"
          >
            <FaWhatsapp className="text-lg transition-transform duration-300 group-hover:rotate-12" />
            <span className="transition-transform duration-300 group-hover:translate-x-1">
              Chat with Us
            </span>
          </a>

          <a
            href={`tel:${whatsappNumber}`}
            className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-all duration-300 hover:scale-105 group"
          >
            <FaPhoneAlt className="text-lg transition-transform duration-300 group-hover:rotate-12" />
            <span className="transition-transform duration-300 group-hover:translate-x-1">
              Missed Call
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;